module.exports = __webpack_public_path__ + "img/news_banl.50770e02.png";